module.exports = __webpack_public_path__ + "static/img/logo.2129473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = iywV
// module chunks = 1